/* Test 2 / V2 — presentation bridge only. Native tier radios retain all logic. */
(function () {
  'use strict';

  function setText(card, selector, value, hideWhenEmpty) {
    var node = card.querySelector(selector);
    if (!node) return;
    node.textContent = value || '';
    if (hideWhenEmpty) node.hidden = !value;
  }

  /*
   * V2's compare prices are deliberate merchandising copy ($219 / $458 / $747).
   * Keep the value rendered by Liquid rather than replacing it with the native
   * variant's compare-at calculation when a shopper switches a tier.
   */
  function designComparePrice(card) {
    var node = card.querySelector('[data-nd-v2-was]');
    if (!node) return '';
    var saved = node.getAttribute('data-nd-v2-design-was');
    if (saved === null) {
      saved = node.textContent.trim();
      node.setAttribute('data-nd-v2-design-was', saved);
    }
    return saved;
  }

  function sync(root) {
    if (!root) return;
    root.querySelectorAll('[data-nd-v2-tier-for]').forEach(function (card) {
      var radio = document.getElementById(card.getAttribute('data-nd-v2-tier-for'));
      if (!radio) return;
      card.classList.toggle('is-selected', radio.checked);
      card.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
      card.setAttribute('aria-disabled', radio.disabled ? 'true' : 'false');
      card.tabIndex = radio.disabled ? -1 : 0;
      setText(card, '[data-nd-v2-price]', radio.getAttribute('data-nd-total-value'));
      setText(card, '[data-nd-v2-was]', designComparePrice(card) || radio.getAttribute('data-nd-was-value'), true);
      setText(card, '[data-nd-v2-save]', radio.getAttribute('data-nd-save-money'), true);
    });
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll('[data-nd-product]').forEach(sync);
  }

  function activate(card) {
    if (!card || card.getAttribute('aria-disabled') === 'true') return;
    var root = card.closest('[data-nd-product]');
    var radio = document.getElementById(card.getAttribute('data-nd-v2-tier-for'));
    if (!root || !radio || radio.disabled) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    sync(root);
  }

  document.addEventListener('click', function (event) {
    activate(event.target.closest && event.target.closest('[data-nd-v2-tier-for]'));
  });

  document.addEventListener('keydown', function (event) {
    var card = event.target.closest && event.target.closest('[data-nd-v2-tier-for]');
    if (!card || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    activate(card);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-nd-tier]')) return;
    window.requestAnimationFrame(function () { sync(event.target.closest('[data-nd-product]')); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(document); });
  } else {
    syncAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { syncAll(event.target); });
}());
